"use client";

import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Quote() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="7576" id="request-a-free-bathroom-remodel-quote" className="bg-background py-28 md:py-36 dark">
      <div className="container mx-auto px-6 md:px-8">
        <div ref={ref} className="mx-auto flex max-w-[760px] flex-col items-center text-center transition-all duration-700 ease-out" style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateY(0)" : "translateY(16px)"
      }}>
          <Badge className="mb-8 rounded-lg border-transparent px-3 py-1.5 text-xs font-semibold tracking-widest uppercase bg-secondary text-secondary-foreground">
            Lakeland, FL
          </Badge>

          <h2 className="font-default font-semibold" style={{
          fontSize: "clamp(2.25rem, 4.5vw, 3.75rem)",
          lineHeight: 1.05,
          letterSpacing: "-0.02em"
        }}>Ready to Start Your Bathroom Remodel?</h2>

          <p className="mt-8 max-w-[540px] font-default text-lg leading-relaxed text-muted-foreground">Request a free bathroom remodel quote in Lakeland, FL. Share a few details about your project and review next steps for your bathroom update, renovation, shower, tub, tile, flooring, vanity, or layout change.</p>

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-5 w-full sm:w-auto">
            <Button asChild className="rounded-lg px-7 py-4 h-auto text-[0.9375rem] font-semibold transition-all duration-200 hover:scale-105 w-full sm:w-auto bg-secondary text-secondary-foreground shadow-lg">
              <Link to="#">Request a Free Quote</Link>
            </Button>

            <Button asChild variant="outline" className="rounded-lg px-7 py-4 h-auto text-[0.9375rem] font-semibold bg-transparent transition-all duration-200 hover:scale-105 w-full sm:w-auto border-primary text-primary">
              <Link to="/ServicesPage">View Services</Link>
            </Button>
          </div>

          <p className="mt-8 font-default text-[0.8125rem] font-medium text-muted-foreground" style={{
          letterSpacing: "0.01em"
        }}>Bathroom remodel quotes · Lakeland, FL · Polk County</p>
        </div>
      </div>
    </section>;
}